export { default as auth_bank_omega_summary } from './auth-bank'
export { default as name_auth_omega_summary } from './name-auth'
export { default as rename_appeal_omega_summary } from './rename-appeal'
export { default as student_auth_omega_summary } from './student-auth'
export { default as blind_omega_summary } from './blind'
export { default as name_identity_omega_summary } from './name-identity'
export { default as admit_appeal_omega_summary } from './admit-appeal'
export { default as auth_bank_bwh_omega_summary } from './auth-bank-bwh'
/**
 * 埋点函数
 * @param {String} name
 * @param {Object} extraParams
 */
export function oMegaData (omegaInfo, extraParams = {}) {
  const name = omegaInfo && omegaInfo.id
  try {
    const params = Object.assign({}, extraParams)
    window.Omega.trackEvent(name, params)
  } catch (err) {
    console.log('omega-erro: ' + name)
  }
}
